import { useSyncExternalStore } from 'react';

import { liveSession } from '../model';

export const useLiveSession = () =>
  useSyncExternalStore(liveSession.subscribe, liveSession.getSnapshot);
